// extracted by mini-css-extract-plugin
export default {"loader":"_1Y6pV","load7":"_2vlcJ"};